// extracted by mini-css-extract-plugin
export default {"fieldSetHolder":"DriverDetail_fieldSetHolder__sSCKI","locationHolder":"DriverDetail_locationHolder__evURJ"};